import { render, staticRenderFns } from "./LayoutContentRendererLeft.vue?vue&type=template&id=fb4beb0c"
import script from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports